// ============================================================
// ALBATROS — Layout.tsx
// Sidebar + estructura principal
// ============================================================

import React from 'react';
import { ViewType } from '../types/view.types';
import {
  ShoppingCart,
  RotateCcw,
  PackageSearch,
  Truck,
  History,
  Settings,
  LogOut,
  Bird
} from 'lucide-react';

/** La pantalla "Reponer Stock" existe pero esta oculta: el pedido se solicita desde el buscador. */
const SHOW_RESTOCK_SECTION = false;

interface LayoutProps {
  view: ViewType;
  setView: (view: ViewType) => void;
  onOpenSettings: () => void;
  onOpenLogout: () => void;
  children: React.ReactNode;
}

function SideIcon({
  icon,
  active,
  onClick,
  title
}: {
  icon: React.ReactNode;
  active: boolean;
  onClick: () => void;
  title?: string;
}) {
  return (
    <button
      onClick={onClick}
      title={title}
      className={`al-side-icon${active ? ' al-side-icon--active' : ''}`}
    >
      {icon}
    </button>
  );
}

export default function Layout({ view, setView, onOpenSettings, onOpenLogout, children }: LayoutProps) {
  return (
    <div className="al-wrapper">

      {/* ── Sidebar ── */}
      <aside className="al-sidebar">

        {/* Logo */}
        <div className="al-sidebar__logo">
          <Bird className="text-white" style={{ width: '1.5rem', height: '1.5rem' }} />
        </div>

        {/* Nav items */}
        <nav className="al-sidebar__nav">
          <SideIcon
            active={view === 'sale'}
            icon={<ShoppingCart style={{ width: '1.5rem', height: '1.5rem' }} />}
            onClick={() => setView('sale')}
            title="Punto de Venta"
          />
          <SideIcon
            active={view === 'returns'}
            icon={<RotateCcw style={{ width: '1.5rem', height: '1.5rem' }} />}
            onClick={() => setView('returns')}
            title="Devoluciones"
          />
          <SideIcon
            active={view === 'orders'}
            icon={<PackageSearch style={{ width: '1.5rem', height: '1.5rem' }} />}
            onClick={() => setView('orders')}
            title="Gestión de Pedidos"
          />
          {SHOW_RESTOCK_SECTION && (
            <SideIcon
              active={view === 'restock'}
              icon={<Truck style={{ width: '1.5rem', height: '1.5rem' }} />}
              onClick={() => setView('restock')}
              title="Reponer Stock"
            />
          )}
          <SideIcon
            active={view === 'movements'}
            icon={<History style={{ width: '1.5rem', height: '1.5rem' }} />}
            onClick={() => setView('movements')}
            title="Historial de Movimientos"
          />
        </nav>

        {/* Bottom icons */}
        <div className="al-sidebar__bottom">
          <SideIcon
            active={false}
            icon={<Settings style={{ width: '1.5rem', height: '1.5rem' }} />}
            onClick={onOpenSettings}
          />
          <SideIcon
            active={false}
            icon={<LogOut style={{ width: '1.5rem', height: '1.5rem', color: '#F87171' }} />}
            onClick={onOpenLogout}
          />
        </div>

      </aside>

      {/* ── Main content ── */}
      <main className="al-main">
        {children}
      </main>

    </div>
  );
}